import React from 'react';

// Fine-line ilustracije za "The line" sekciju (Explore & Master). Svaka priča
// priču iz teksta te faze kao PUT (linija) sa tri stanice — po jedna za svaki
// bullet — od početne tačke do cilja (zastavica). Stil: tanka linija u brend
// ink boji (currentColor se postavlja na wrapperu), sa blagim brend dodirom.

// Zajednička "kičma" linije + medaljoni + start/cilj.
function Spine() {
  return (
    <>
      <circle cx="75" cy="32" r="3" fill="currentColor" stroke="none" />
      <path d="M75,32 V43" /><path d="M75,97 V148" /><path d="M75,202 V253" /><path d="M75,307 V338" />
      {/* cilj — zastavica */}
      <path d="M75,338 V353" /><path d="M75,338 L88,342.5 L75,347 Z" />
      {/* stanice */}
      <circle cx="75" cy="70" r="27" /><circle cx="75" cy="175" r="27" /><circle cx="75" cy="280" r="27" />
    </>
  );
}

// ── Explore: prospecting → content knowledge → self-development ──────────────
function ExploreLine() {
  return (
    <svg viewBox="0 0 150 365" width="100%" fill="none" stroke="currentColor"
      strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ display: 'block' }}>
      <Spine />
      {/* 1 · Proactive Prospecting — lupa koja skenira prospekte */}
      <circle cx="72" cy="66" r="9" /><path d="M78.5,72.5 L86,80" />
      <circle cx="62" cy="80" r="1.7" fill="currentColor" stroke="none" />
      <circle cx="69" cy="84" r="1.7" fill="currentColor" stroke="none" />
      <circle cx="58" cy="73" r="1.7" fill="currentColor" stroke="none" />
      {/* 2 · Comprehensive Content Knowledge — otvorena knjiga (programi) */}
      <path d="M75,168 C68,164 60,164 55,167 L55,184 C60,181 68,181 75,185 Z" />
      <path d="M75,168 C82,164 90,164 95,167 L95,184 C90,181 82,181 75,185 Z" />
      <path d="M75,168 V185" />
      <g strokeWidth="0.7" strokeOpacity="0.7">
        <path d="M60,173 C64,171 69,171 72,173" /><path d="M60,178 C64,176 69,176 72,178" />
        <path d="M78,173 C81,171 86,171 90,173" /><path d="M78,178 C81,176 86,176 90,178" />
      </g>
      {/* 3 · Self-Awareness & Personal Development — izdanak koji raste */}
      <path d="M64,293 C69,291 81,291 86,293" />
      <path d="M75,293 C75,283 75,279 75,270" />
      <path d="M75,283 C69,280 64,282 62,287 C67,289 72,286 75,284" />
      <path d="M75,287 C81,284 86,286 88,291 C83,293 78,290 75,288" />
    </svg>
  );
}

// ── Master: needs assessment → development → proposing & closing ────────────
function MasterLine() {
  return (
    <svg viewBox="0 0 150 365" width="100%" fill="none" stroke="currentColor"
      strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ display: 'block' }}>
      <Spine />
      {/* 1 · Client Needs Assessment — pitanje (open questions) + talasi (active listening) */}
      <ellipse cx="72" cy="64" rx="15" ry="10.5" />
      <path d="M66,72 L62,80 L72,72.5" />
      <path d="M68,60 C68,55.5 76,55.5 76,60 C76,63.5 72,63 72,66.5" strokeWidth="1.2" />
      <circle cx="72" cy="69.5" r="0.9" fill="currentColor" stroke="none" />
      <path d="M90,59 C93.5,62.5 93.5,65.5 90,69" strokeWidth="1.1" />
      <path d="M94,55.5 C99.5,61 99.5,67 94,72.5" strokeWidth="1.1" />
      {/* 2 · Programme Content Development — sklapanje blokova + olovka */}
      <rect x="64" y="180" width="12" height="12" />
      <rect x="76" y="180" width="12" height="12" />
      <rect x="70" y="168" width="12" height="12" />
      <path d="M85,163 L93,171" /><path d="M82.5,160.5 L85,163 L87.5,165.5" />
      {/* 3 · Proposing & Closing — predlog + kvačica (dogovor) */}
      <path d="M67,267 H82 L86,271 V297 H67 Z" />
      <path d="M82,267 V271 H86" />
      <g strokeWidth="0.8" strokeOpacity="0.75">
        <path d="M71,276 H81" /><path d="M71,281 H81" /><path d="M71,286 H77" />
      </g>
      <circle cx="84" cy="293" r="6" /><path d="M81.2,293 L83.5,295.3 L87.2,289.8" />
    </svg>
  );
}

export default function PhaseIllustration({ phase }) {
  if (phase === 'E') return <ExploreLine />;
  if (phase === 'M') return <MasterLine />;
  return null;
}
